import styled from "styled-components";

const ResultText = styled.span `
    font-size: 20px;
    color: black;
    width: 100%;
`

export default ResultText